import {
  NgModule,
} from '@angular/core';
import {
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  SeatmapFactsService,
} from './seatmap.facts.service';

@NgModule({
  imports: [
    RulesEngineRunnerModule
  ],
  providers: [
    SeatmapFactsService
  ]
})
export class SeatmapFactsModule {}
